export default "__VITE_ASSET__BI9_ya6C__"